module.exports = __webpack_public_path__ + "img/ask.88cf9c54.jpg";